// extracted by mini-css-extract-plugin
export default {"Wrapper":"SimpleKeypoints_Wrapper__n5Apq","Main":"SimpleKeypoints_Main__qJUFs","ImageWrapper":"SimpleKeypoints_ImageWrapper__oa1H0","Middle":"SimpleKeypoints_Middle__UqBE6"};